import { render, staticRenderFns } from "./sh_Root.vue?vue&type=template&id=2e27aa0c&scoped=true&"
import script from "./sh_Root.vue?vue&type=script&lang=js&"
export * from "./sh_Root.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/godmode_banner.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./sh_Root.vue?vue&type=style&index=1&id=2e27aa0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27aa0c",
  null
  
)

export default component.exports